<template>
  <header :class="{ 'scrolled': headerScrolled, 'dtm-trophy': isDtmTrophy }">
    <div class="container-fluid">
      <div class="row no-gutters">
        <div class="col-auto align-content-center">
          <router-link :to="`/${$i18n.locale}/dtm-trophy`" v-if="isDtmTrophy" class="logo-b">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 10 230 80" class="logo-svg">
              <rect width="100%" height="115%" mask="url(#dtm-trophy-logo)" />
            </svg>
          </router-link>
          <router-link to="/" v-else class="logo-a"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 180 49" class="logo-svg">
            <rect width="100%" height="100%" mask="url(#dtm-logo)" />
          </svg></router-link>
        </div>
        <div class="col align-self-center">
          <div class="d-block hide-desktop text-align--right">
            <div @click="menuOpen = true" class="main-menu__open-button" :class="{ 'main-menu__open-button--open': menuOpen }">
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
          <div class="main-menu" :class="{ 'main-menu--open': menuOpen }">
            <div class="d-block hide-desktop">
              <div @click="menuOpen = false" class="main-menu__close-button">
                <div></div>
                <div></div>
              </div>
            </div>
            <div class="row justify-content-end align-items-lg-center flex-column flex-lg-row">
              <div v-for="(item, index) in navItems" :key=index  class="col-auto">
                <a class="main-menu__link" :class="{ 'button-ghost': item.button }"  v-if="item.external && item.url" :href="item.url" target="_blank">{{ item.title }}</a>
                <router-link class="main-menu__link" :class="{ 'button-ghost primary': item.button }" v-if="!item.external && item.url && !item.switch" :to="`/${$i18n.locale}/${item.url}`">
                  {{ item.title }}
                </router-link>
                <router-link :to="isDtmTrophy ? '/' : `/${$i18n.locale}/${item.url}`" v-if="item.switch">
                  <RouteSwitch class="main-menu__link" @click="switchToggle = !switchToggle"
                               :class="{ 'switch': item.switch, 'dtm-trophy': isDtmTrophy, 'dtm': !isDtmTrophy }"
                               :value="isDtmTrophy"
                               :checked-text="!isDtmTrophy ? 'DTM Trophy' : 'DTM'"
                               :unchecked-text="isDtmTrophy ? 'DTM' : 'DTM Trophy'"
                               height="26"
                               width="104"/>
                </router-link>
              </div>
              <LanguageSwitcher class="padding--top-1 padding--top-lg-0" :class="{ 'dtmTrophyStyle': isDtmTrophy}" />
            </div>
            <div class="main-menu__close-div" @click="menuOpen = false"></div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import AppConst from '../config/app.const';
import LanguageSwitcher from './LanguageSwitcher.vue';
import Settings from '../config/settings';
import RouteSwitch from './HeaderToggleRouteSwitch';

export default {
  name: 'Header',
  components: {
    RouteSwitch,
    LanguageSwitcher
  },
  data () {
    return {
      headerScrolled: false,
      navItems: [],
      menuOpen: false,
      queryType: this.$store.getters['page/raceSeriesNavigation'],
      switchToggle: true
    };
  },
  watch: {
    '$route' () {
      this.menuOpen = false;
    }
  },
  computed: {
    isDtmTrophy: function () {
      return this.$store.getters['page/raceSeries'] === 'dtm-trophy';
    }
  },
  methods: {
    async fetchHeaderNavigation () {
      await this.$store.dispatch(AppConst.FETCH_PATH_NAME, {
        path: `data?query=${this.queryType}`,
        lifetime: Settings.LIFETIME_STATIC
      })
        .then(response => {
          response.navigations.forEach(navigation => {
            this.navItems = navigation.navItems;
          });
        })
        .catch(() => {
          setTimeout(this.fetchHeaderNavigation, 3000);
        });
    }
  },
  created () {
    // fetch the navigation items
    this.fetchHeaderNavigation();
    // we watch the scrollTop value
    this.unwatchScrollTop = this.$store.watch(() => this.$store.getters['scroll/scrollTop'], scrollTop => {
      // set headerScrolled true/false if threshold is reached
      this.headerScrolled = scrollTop > 50;
    });
    // set navigation query name after route changes
    this.unwatchQueryType = this.$store.watch(() => this.$store.getters['page/raceSeriesNavigation'], raceSeriesNavigation => {
      // if not in current raceSeries fetch new navigation for different context
      if (this.queryType !== raceSeriesNavigation) {
        this.queryType = raceSeriesNavigation;
        this.fetchHeaderNavigation();
      }
    });
  },
  beforeDestroy () {
    this.unwatchScrollTop();
    this.unwatchQueryType();
  }
};
</script>

<style lang="scss" scoped>
  .logo-svg {
    margin: 25px 25px 25px 0;
    transition: all .5s $ease-out-cubic;
    width: 180px;
    height: 49px;
    rect {
      fill: $color-primary;
      transition: all .3s;
    }
  }
  .logo-a {
    outline: none;
    line-height: 0;
    font-size: 0;
    display: block;
    &:hover {
      .logo-svg rect {
        fill: #fff;
      }
    }
  }
  .logo-b {
    outline: none;
    line-height: 0;
    font-size: 0;
    display: inline-block;
    .logo-svg rect {
      fill: $color-bg-trophy;
    }
    &:hover {
      .logo-svg rect {
        fill: $color-bg-dark-trophy;
      }
    }
  }
  .main-menu {
    &__link {
      text-decoration: none;
      text-transform: uppercase;
      font-style: italic;
      transition: color 0.3s ease;
    }
  }
  header {
    background: $color-bg;
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    z-index: 900;
    transition: background .3s linear;

    &.scrolled {
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.4);

      .logo-svg {
        margin: 17px 17px 17px 0;
        width: 126px;
        height: 34.3px;
      }
    }

    /* Style for header and NavItems in Dtm-Trophy */
    &.dtm-trophy {
      background-color: $color-primary-trophy;

      .main-menu {
        &__link {
          color: $color-bg-trophy;

          &:hover {
            color: $color-bg-dark-trophy;
          }
        }
      }
    }
  }

  @media (max-width: map_get($grid-breakpoints, 'lg')) {
    header {
      .logo-svg, &.scrolled .logo-svg {
        margin: 20px 17px 20px 0;
        width: 100px;
        height: 27.22px;
      }
      /* Style for NavItems in Dtm-Trophy in burger menu */
      &.dtm-trophy {
        .main-menu {
          &__link {
            color: #ffffff;
            &:hover {
              color: $color-primary-trophy;
            }
          }
        }
      }
    }

    .main-menu {
      $root: &;
      position: fixed;
      left: 0;
      right: 0;
      top: 0;
      height: 100vh;
      background: rgba($color-bg-dark, 0);
      padding: $gap $gap $gap $gap * 2;
      text-align: right;
      transform: translate(100%, 0);
      transition: transform .4s $ease-in-quad .2s, background .2s linear;
      &:before {
        content: '';
        position: absolute;
        z-index: -1;
        width: 400px;
        right: 0;
        top: 0;
        bottom: 0;
        background: $color-bg-dark;
      }
      .row {
        .col-auto {
          opacity: 0;
          transform: translate($gap, 0);
          transition: all .2s linear .4s;
        }
      }
      &__open-button {
        transform: translate(0, 4px);
        width: 48px;
        height: 48px;
        display: inline-block;
        position: relative;
        div {
          height: 2px;
          background: #fff;
          width: 24px;
          position: absolute;
          left: 12px;
          transition: all .3s $ease-out-quad;
          &:nth-child(1) {
            top: 16px;
            transition-delay: .7s;
          }
          &:nth-child(2) {
            top: 50%;
            transform: translate(0, -50%);
            transition-delay: .75s;
          }
          &:nth-child(3) {
            bottom: 16px;
            transition-delay: .8s;
          }
        }
        &--open {
          div {
            width: 0;
            &:nth-child(1) {
              transition-delay: 0s;
            }
            &:nth-child(2) {
              transition-delay: .05s;
            }
            &:nth-child(3) {
              transition-delay: .1s;
            }
          }
        }
      }
      &__close-div {
        position: absolute;
        left: 0;
        width: $gap * 2;
        top: 0;
        bottom: 0;
      }
      &__close-button {
        width: 48px;
        height: 40px;
        display: inline-block;
        position: relative;
        div {
          position: absolute;
          width: 0;
          height: 2px;
          background: #fff;
          transition: all .3s $ease-out-quad;
          &:nth-child(1) {
            top: 10px;
            left: 12px;
            transform: rotate(45deg);
            transform-origin: left center;
            transition-delay: 0s;
          }
          &:nth-child(2) {
            bottom: 10px;
            left: 12px;
            transform: rotate(-45deg);
            transform-origin: left center;
            transition-delay: .1s;
          }
        }
      }
      &__link {
        display: inline-block;
        padding: $gap;
        font-style: normal;
        &.button-ghost {
          display: inline-block;
        }
        &.switch {
          padding: 0;
        }
      }
      &--open {
        background: rgba($color-bg-dark, .7);
        transform: translate(0, 0);
        transition: transform .4s $ease-out-quad .3s, background .3s linear .7s;
        #{$root}__close-button {
          div {
            width: 26px;
            &:nth-child(1) {
              transition-delay: .7s;
            }
            &:nth-child(2) {
              transition-delay: .8s;
            }
          }
        }
        .row {
          .col-auto {
            opacity: 1;
            transform: translate(0, 0);
            transition: all .3s $ease-out-quad .7s;
          }
        }
      }
    }
    header.dtm-trophy {
      .main-menu {
        &__open-button {
          div {
            background: $color-bg-trophy;
          }
        }
      }
    }
  }

  @media (max-width: map_get($grid-breakpoints, 'md')) {
    .main-menu {
      $root: &;
      &:before {
        left: $gap * 2;
        width: auto;
      }
      &__link {
        display: block;
        &.switch {
          display: inline-block;
        }
      }
    }
  }

  @media all and (min-width: 769px) {
    .hide-desktop {
      display: none;
    }
  }
</style>
